/*
 * O calendário da vigência de contrato.
 *
 * É o UTC, e não o fuso do navegador: a competência é UTC (doc 01 §4.1), e as
 * consultas de vigência do servidor leem o dia em UTC explícito. Uma tela que
 * propusesse "hoje" pelo relógio local mandaria, entre 21h e meia-noite em
 * Brasília, um dia que para o servidor já é ontem — e levaria
 * `422 vigencia_invalida` por "fim no passado".
 */

function paraDia(instante: Date): string {
  return instante.toISOString().slice(0, 10);
}

/** Hoje no calendário UTC, como `2026-10-25`. */
export function hojeUTC(agora: Date = new Date()): string {
  return paraDia(agora);
}

/** O dia 1º do mês seguinte, em UTC: a data natural de uma troca de plano. */
export function primeiroDoProximoMes(agora: Date = new Date()): string {
  return paraDia(new Date(Date.UTC(agora.getUTCFullYear(), agora.getUTCMonth() + 1, 1)));
}

/** A véspera de um dia (`2026-11-01` → `2026-10-31`). */
export function vespera(diaISO: string): string {
  const [ano, mes, dia] = diaISO.split("-").map(Number);
  if (ano === undefined || mes === undefined || dia === undefined) return diaISO;
  return paraDia(new Date(Date.UTC(ano, mes - 1, dia - 1)));
}

/** Se o dia é o primeiro do mês. */
export function ehDiaPrimeiro(diaISO: string): boolean {
  return diaISO.slice(8, 10) === "01";
}

function paraCompetencia(ano: number, mesIndice: number): string {
  return paraDia(new Date(Date.UTC(ano, mesIndice, 1))).slice(0, 7);
}

/** A competência em andamento, em UTC, como `2026-10`. */
export function competenciaCorrente(agora: Date = new Date()): string {
  return paraCompetencia(agora.getUTCFullYear(), agora.getUTCMonth());
}

/**
 * A competência anterior à corrente, em UTC: a que se fecha no mês seguinte,
 * depois da carência.
 */
export function competenciaAnterior(agora: Date = new Date()): string {
  return paraCompetencia(agora.getUTCFullYear(), agora.getUTCMonth() - 1);
}
